'use client'

import type { ReactNode } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter, useInRouterContext } from 'react-router-dom'

import { queryClient } from '../../../api/query-client'
import { RightModal } from '../modals/RightModal'
import FilterWindowNew from '../modalsContent/FilterWindowNew'

type Props = {
  onToggle: () => void
  open: boolean
  setOpen: (open: boolean) => void
}

const RouterBoundary = ({ children }: { children: ReactNode }) => {
  const hasParentRouter = useInRouterContext()

  return hasParentRouter ? children : <BrowserRouter>{children}</BrowserRouter>
}

export const HeaderFilterMenu = ({ onToggle, open, setOpen }: Props) => {
  if (!open) {
    return null
  }

  return (
    <QueryClientProvider client={queryClient}>
      <RouterBoundary>
        <RightModal setViewModal={setOpen} viewModal={open}>
          <FilterWindowNew handleFilterModalOpen={onToggle} isSearch />
        </RightModal>
      </RouterBoundary>
    </QueryClientProvider>
  )
}
